<div bsModal #createOrEditModal="bs-modal" class="modal right fade" tabindex="-1" role="dialog" aria-labelledby="createOrEditModal" aria-hidden="true" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form *ngIf="active" #addressForm="ngForm" novalidate (ngSubmit)="save()" autocomplete="off" class="h-100">
        <div class="modal-content-wrapper">
          <div class="modal-header" style="display: block;background-color: #ffffff !important;">
                <h4 class="modal-title" style="display: block;">
                    <span *ngIf="address.id">{{l("EditAddress")}}</span>
                    <span *ngIf="!address.id">{{l("AddnewAddressDetails")}}</span>
                </h4>
                <p>{{l("PleaseEnterTheNewAddressInformation")}}</p>
                <button style="position: absolute;right: 0;top: 8px;" type="button" class="close" (click)="cancel()" aria-label="Close" [disabled]="saving">
                    <span aria-hidden="true">&times;</span>
                </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="address_Code">{{l("Code")}} *</label>

                <input [disabled]="address?.id>0" type="text" id="address_Code" class="form-control form-control-sm aria-input-text" [(ngModel)]="addressCode" name="code" maxlength="6"/>
            </div>

            <div class="form-group">
              <label for="address_Name">{{l("Name")}} *</label>
              <input type="text" id="address_Name" class="form-control form-control-sm aria-input-text" [(ngModel)]="address.name" name="Name" required  />
            </div>

            <div class="form-group">
              <label for="address_AddressLine1">{{l("AddressLine")}} 1 *</label>
              <input type="text" id="address_AddressLine1" class="form-control form-control-sm aria-input-text" [(ngModel)]="address.addressLine1" name="AddressLine1"   required  />
            </div>

            <div class="form-group">
              <label for="address_AddressLine2">{{l("AddressLine")}} 2</label>
              <input type="text" id="address_AddressLine2" class="form-control form-control-sm aria-input-text" [(ngModel)]="address.addressLine2" name="AddressLine2" />
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address_City">{{l("City")}} *</label>
                  <input type="text" id="address_City" class="form-control form-control-sm aria-input-text" [(ngModel)]="address.city" name="City" required  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="address_State">{{l("State")}} *</label>
                  <input type="text" id="address_State" class="form-control form-control-sm aria-input-text" [(ngModel)]="address.state" name="State" required  />
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="address_PostalCode">{{l("PostalCode")}} *</label>
              <input type="text" id="address_PostalCode" class="form-control form-control-sm aria-input-text" [(ngModel)]="address.postalCode" name="PostalCode"  required   />
            </div>

            <div class="form-group">
              <label class="mr-3" for="country">{{l("Country")}}</label>
              <p-dropdown
                  id="country"
                  [options]="allCountries"
                  [(ngModel)]="address.countryId"
                  name="address.countryId"
                  styleClass="form-control aria-select"
                 
                  [placeholder]="'PleaseSelect' | localize"
              >
              </p-dropdown>
      
            </div>

          </div>
          <div class="modal-footer">
              <button [disabled]="saving" type="button" class="btn btn-default  btn-gray mr-2" (click)="cancel()">{{l("Cancel")}}</button>
              <button type="submit" class="btn bgPurple mr-2" [disabled]="!addressForm.form.valid" [buttonBusy]="saving" [busyText]="l('SavingWithThreeDot')"> <span>{{l("Save")}}</span></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

